import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const DESTINATIONINCOTERM_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.DestinationIncoTerm.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const DESTINATIONINCOTERM_CONFIG = {
  entityName: 'DestinationIncoTerm',
  localizationKey: 'General::Entity.DestinationIncoTerm',
  fields: DESTINATIONINCOTERM_FIELDS,
  permission: 'ControllingLiquidations.DestinationIncoTerms',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
